import {useSelector} from "react-redux";

function useGetUserDetail(id) {
  const {
    value: {data: users},
  } = useSelector((rootState) => rootState.userList.userList);

  return users.filter((user) => {
    return user.key === id;
  })[0];
}

export default useGetUserDetail;
